import UpdatePayRoll from "pages/PayRoll/UpdatePayRoll";
import { lazy } from "react";
import { MODAL } from "redux/slices/modal";

import AddAttachment from "./AddAttachment";
import EditMapAddress from "./EditMapAddress";
import MapWithPin from "./MapWithPin";
import UpdateDynamics from "./UpdateDynamics";
import UpdatePaymentStatus from "./UpdatePaymentStatus";
import Refund from "./Refund/Refund";
import ConfirmRefund from "./ConfirmRefund/ConfirmRefund";
import BookingDetails from "./BookingDetails";
import AddShift from "./AddShift";
import SetSmartScript from "./SetSmartScript";
import UpdatePaymentLink from "./UpdatePaymentLink";

const AddNotes = lazy(() => import("./AddNotes"));
const EditSpecialPrice = lazy(() => import("./EditSpecialPrice"));
const DeleteUser = lazy(() => import("./DeleteUser"));
const AddPayment = lazy(() => import("./AddPayment"));
const PayInvoice = lazy(() => import("./PayInvoice"));
const HandleStatus = lazy(() => import("./HandleStatus"));
const DisableModal = lazy(() => import("./DisableModal"));
const SendContract = lazy(() => import("./SendContract"));
const AssignBooking = lazy(() => import("./AssignBooking"));
const CancelBooking = lazy(() => import("./CancelBooking"));
const RequestCancellation = lazy(() => import("./RequestCancellation"));
const ChildrenSeats = lazy(() => import("./ChildrenSeats"));
const UploadDocs = lazy(() => import("./UploadCompanyDocs"));
const AssignNewPrice = lazy(() => import("./AssignNewPrice"));
const UploadDocument = lazy(() => import("./UploadDocument"));
const UploadContacts = lazy(() => import("./UploadContacts"));
const DriverSubStatus = lazy(() => import("./DriverSubStatus"));
const UpdateTanfeethi = lazy(() => import("./UpdateTanfeethi"));
const UpdateAlMasar = lazy(() => import("./UpdateAlMasar"));
const CloseTicketForm = lazy(() => import("./CloseTicketForm"));
const VehicleSubStatus = lazy(() => import("./VehicleSubStatus"));
const ConfirmationForm = lazy(() => import("./ConfirmationForm"));
const CarMovementFinish = lazy(() => import("./CarMovementFinish"));
const ConfirmationModal = lazy(() => import("./ConfirmationModal"));
const RefundPaymentLink = lazy(() => import("./RefundPaymentLink"));
const SearchHistoryStats = lazy(() => import("./SearchHistoryStats"));
const ExportTableOptions = lazy(() => import("./ExportTableOptions"));
const DynamicCarMovement = lazy(() => import("./DynamicCarMovement"));
const UpdateCountryPrice = lazy(() => import("./UpdateCountryPrices"));
const UpdateAggregatorMarkup = lazy(() => import("./UpdateAggregatorMarkup"));
const UpdateBookingStatus = lazy(() => import("./UpdateBookingStatus"));
const MarketTransferPopup = lazy(() => import("./MarketTransferPopup"));
const ProtectionAndExtrasDetails = lazy(
  () => import("./ProtectionAndExtrasDetails/ProtectionAndExtrasDetails"))
const UpdatePaymentForBooking = lazy(() => import("./UpdatePaymentForBooking"));
const UpdateBookingBillingAddress = lazy(
  () => import("./UpdateBookingBillingAddress"),
);
const HandoverCategory = lazy(() => import("./HandoverCategory"));
const HandoverSubCategory = lazy(() => import("./HandoverSubCategory"));
const EditKioskDevice = lazy(() => import("./EditKioskDevice"));
const ReturnAsset = lazy(() => import("./ReturnAsset"));
const ReturnECar = lazy(() => import("./ReturnECar"));
const GenerateDriverReport = lazy(() => import("./GenerateDriverReport"));
const DriverAttendance = lazy(() => import("./DriverAttendance"));
const UpdateDriverPosition = lazy(() => import("./UpdateDriverPosition"));
const CampaignRevenue = lazy(() => import("./CampaignRevenue"));
const AggregatorDetails = lazy(() => import("./AggregatorDetails"));
const UpdateMcBooking = lazy(() => import("./UpdateMcBooking"));
const HourlyDestinationModal = lazy(() => import("./HourlyDestinationModal"));
const DynamicSelections = lazy(
  () => import("./DynamicSelections/DynamicSelections"),
);
const AddIndividualDiscount = lazy(() => import("./AddIndividualDiscount"));

const AddCarCategory = lazy(() => import("./delivery/AddCarCategory"));
const AddCarExtra = lazy(() => import("./delivery/AddCarExtra"));
const UpdateDeliveryBooking = lazy(
  () => import("./delivery/UpdateDeliveryBooking"),
);
const UpdateStatus = lazy(() => import("./delivery/UpdateStatus/UpdateStatus"));
const CancleStatus = lazy(() => import("./delivery/CancleStatus/CancleStatus"));
const ImageGallery = lazy(() => import("./ImageGallery/ImageGallery"));
const MarkExtraChargePaid = lazy(
  () => import("./delivery/MarkExtraChargePaid"),
);
const AssignDriver = lazy(() => import("./delivery/AssignDriver"));
const AddCompanyInvoice = lazy(() => import("./AddCompanyInvoice"));

export { default } from "./AppModal";

export type ModalMapper = {
  [key in MODAL]: "" | JSX.Element;
};

export const modalMapper: ModalMapper = {
  ADD_NOTES: <AddNotes />,
  PAY_INVOICE: <PayInvoice />,
  DELETE_USER: <DeleteUser />,
  ADD_PAYMENT: <AddPayment />,
  HANDLE_STATUS: <HandleStatus />,
  DISABLE_DRIVER: <DisableModal />,
  CHILDREN_SEATS: <ChildrenSeats />,
  ASSIGN_BOOKING: <AssignBooking />,
  CANCEL_BOOKING: <CancelBooking />,
  REQUEST_CANCELLATION: <RequestCancellation />,
  UPLOAD_DOCUMENT: <UploadDocument />,
  UPLOAD_CONTACTS: <UploadContacts />,
  UPLOAD_DOC: <UploadDocs />,
  CONFIRMATION_FORM: <ConfirmationForm />,
  CLOSE_TICKET_FORM: <CloseTicketForm />,
  UPDATE_PAYMENT_LINK_FORM: <UpdatePaymentLink />,
  EDIT_SPECIAL_PRICE: <EditSpecialPrice />,
  MARKET_TRANSFER: <MarketTransferPopup />,
  CONFIRMATION_MODAL: <ConfirmationModal />,
  EXPORT_TABLE_OPTIONS: <ExportTableOptions />,
  UPDATE_BOOKING_STATUS: <UpdateBookingStatus />,
  UPDATE_BOOKING_BILLING_ADDRESS: <UpdateBookingBillingAddress />,
  UPDATE_PAYROLL: <UpdatePayRoll />,
  UPDATE_DYNAMICS: <UpdateDynamics />,
  UPDATE_PAYMENT_STATUS: <UpdatePaymentStatus />,
  ADD_ATTACHMENT: <AddAttachment />,
  EDIT_ADDRESS: <EditMapAddress />,
  EDIT_ADDRESS1: <MapWithPin />,
  REFUND: <Refund />,
  CONFIRM_REFUND: <ConfirmRefund />,
  SEARCH_HISTORY_STATS: <SearchHistoryStats />,
  ASSIGN_PRICE: <AssignNewPrice />,
  UPDATE_CROSS_COUNTRY_PRICE: <UpdateCountryPrice />,
  UPDATE_AGGREGATOR_MARKUP: <UpdateAggregatorMarkup />,
  UPDATE_TANFEETHI: <UpdateTanfeethi />,
  UPDATE_AL_MASAR: <UpdateAlMasar />,
  BOOKING_DETAILS: <BookingDetails />,
  Add_SHIFT: <AddShift />,
  DYNAMIC_CAR_MOVEMENT: <DynamicCarMovement />,
  FINISH_CAR_MOVEMENT: <CarMovementFinish />,
  INDIVIDUAL_DISCOUNT: <AddIndividualDiscount />,
  SET_SMART_SCRIPT: <SetSmartScript />,
  DYNAMIC_SELECTIONS: <DynamicSelections />,
  VEHICLE_SUB_STATUS: <VehicleSubStatus />,
  DRIVER_SUB_STATUS: <DriverSubStatus />,
  ADD_DELIVERY_CAR_CATEGORY: <AddCarCategory />,
  ADD_DELIVERY_CAR_EXTRA: <AddCarExtra />,
  UPDATE_DELIVERY_BOOKING: <UpdateDeliveryBooking />,
  UPDATE_STATUS: <UpdateStatus />,
  CANCLE_STATUS: <CancleStatus />,
  IMAGE_GALLERY: <ImageGallery />,
  PROTECTION_DETAILS: <ProtectionAndExtrasDetails />,
  MARK_EXTRA_CHARGE_PAID: <MarkExtraChargePaid />,
  ASSIGN_DRIVER: <AssignDriver />,
  ADD_COMPANY_INVOICE: <AddCompanyInvoice />,
  UPDATE_PAYMENT_FOR_BOOKING: <UpdatePaymentForBooking />,
  SEND_CONTRACT: <SendContract />,
  REFUND_PAYMENT_LINK: <RefundPaymentLink />,
  HANDOVER_CATEGORY: <HandoverCategory />,
  HANDOVER_SUBCATEGORY: <HandoverSubCategory />,
  EDIT_KIOSK_DEVICE: <EditKioskDevice />,
  RETURN_ASSET: <ReturnAsset />,
  RETURN_ECAR: <ReturnECar />,
  GENERATE_DRIVER_REPORT: <GenerateDriverReport />,
  DRIVER_ATTENDANCE: <DriverAttendance />,
  DRIVER_POSITION: <UpdateDriverPosition />,
  CAMPAIGN_REVENUE: <CampaignRevenue />,
  UPDATE_MC_BOOKING: <UpdateMcBooking />,
  AGGREGATOR_DETAILS: <AggregatorDetails />,
  HOURLY_DESTINATION: <HourlyDestinationModal />,
};
